import React, { useState } from "react";
import { PurchaseData } from "../../api/mockData";
import { PurchasedItem } from "../PurchasedItem";
import { Accordion } from "../Accordion";
import { PurchasedModal } from "../PurchasedModal";
import { Section } from "../Section";
import {
  AccordionListWrap,
  ListWrap,
  NeedField,
  SmallDescription,
} from "./elements";

export interface Spec {
  id: number;
  gb: string;
  noScratches: string;
  someScratches: string;
  noticeableScratches: string;
  crackedScreen: string;
}

export const PurchasedList: React.FC = React.memo(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState("");
  const [selectedName, setSelectedName] = useState("");

  const [selectedSpec, setSelectedSpec] = useState<Spec | undefined>({
    id: 0,
    gb: "",
    noScratches: "",
    someScratches: "",
    noticeableScratches: "",
    crackedScreen: "",
  });

  return (
    <Section title="買取商品一覧">
      <ListWrap>
        <NeedField>
          <label>web申し込みの手順</label>
          <SmallDescription>
            1. お売りいただく端末を以下から選択。
          </SmallDescription>
          <SmallDescription>
            2. 端末のメモリを選択し対象状態の申込ボタンを押す。
          </SmallDescription>
          <SmallDescription>
            3. 申込ページにて全ての項目を入力後、送信して完了。
          </SmallDescription>
        </NeedField>
        <AccordionListWrap>
          {PurchaseData.map((item, index) => {
            return (
              <Accordion
                isSmall={false}
                key={`accordion-item${index}`}
                title={item.series}
                list={item.model}
              >
                <PurchasedItem
                  series={item.series}
                  model={item.model}
                  setSelectedSeries={setSelectedSeries}
                  setSelectedName={setSelectedName}
                  setSelectedSpec={setSelectedSpec}
                  setIsModalOpen={setIsModalOpen}
                />
              </Accordion>
            );
          })}
        </AccordionListWrap>
        {isModalOpen && (
          <PurchasedModal
            series={selectedSeries}
            selectedName={selectedName}
            selectSpec={selectedSpec}
            setIsModalOpen={setIsModalOpen}
          />
        )}
      </ListWrap>
    </Section>
  );
});

PurchasedList.displayName = "PurchasedList";
